<template>
  <!-- 
    name: 覃刚
    function: 原料数据库-新增
    date: 2021-03-15
 -->
  <div class="modalBox">
    <div class="nurientHead">
      <div class='left'>
        <a-input-search v-model="formData.keyword" placeholder="原料名称/代码" @search="onSearch">
          <a-button slot="enterButton">
            搜索
          </a-button>
        </a-input-search>
      </div>
      <div class="middle"></div>
      <div class="right">
        <a-cascader
          v-model="typeArr"
          :options="typeList"
          :load-data="loadData"
          placeholder="请选择类型"
          change-on-select
           style="width: 180px;margin-right: 20px;float: right"
          @change="changeType"
        />
      </div>
    </div>
    <a-table :columns="columns" :data-source="list" class="tableBox" :row-selection="rowSelection" :pagination="pagination" @change="getList" rowKey="id">
      <span slot="sort" slot-scope="t,r,index">{{index + 1}}</span>
    </a-table>
    <div class="selectCount">
      已选中 <span class="colorRed">{{this.selectList.length || 0}}</span> 个营养指标
    </div>
  </div>
</template>
<script>
export default {
  props:{
    typeList: Array,
    default:() => {
      return []
    }
  },
  data(){
    return {
      name: 'ddd',
      typeArr:[],
      pagination: {
        total:0,
        pageSize:20,
        current: 1
      },
      selectList:[],
      selectId:[],
      formData:{
        typeArr: [],
        keyword: ''
      },
      list:[],
      columns: [
        {
          title: '序号',
          dataIndex: 'sort',
          width: 80,
          scopedSlots: { customRender: 'sort' },
        },
        {
          title: '指标名称',
          dataIndex: 'name',
          width: 120,
        },
        {
          title: '代码',
          dataIndex: 'code',
          width: 120,
        },
        {
          title: '全称',
          dataIndex: 'fullName',
          width: 180,
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          width: 150,
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: 80,
        }
      ],
    }
  },
  computed:{
    rowSelection(){
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // 更新当前页选中的ID
          this.selectList = selectedRowKeys
          
          // 获取当前页所有数据的ID
          const currentPageIds = this.list.map(item => item.id)
          
          // 移除当前页中未选中的ID
          this.selectId = this.selectId.filter(id => !currentPageIds.includes(id))
          
          // 添加当前页新选中的ID
          selectedRows.forEach(el => {
            if(!this.selectId.includes(el.id)) {
              this.selectId.push(el.id)
            }
          })
        },
        selectedRowKeys: this.selectList,
        getCheckboxProps: record => ({
          props: {
            disabled: record.chooseStatus === '1'
          },
        }),
      }
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    changeType(value){
      if(value && value.length > 0){
        this.formData.typeId = value[value.length - 1]
      }else{
        this.formData.typeId = undefined
      }
      // 切换类型时清空选中状态
      this.selectList = []
      this.selectId = []
      this.getList({current:1,pageSize:this.pagination.pageSize})
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        this.$emit('getTypeList',{targetOption,id:targetOption.id})
        // this.getTypeList(targetOption.id,targetOption) || []
        // this.typeList = [...this.typeList];
      }, 0);
    },
    getList(pagination){
      let {current=1,size=10} = pagination || {}
      let params = {
        current,
        size,
        ...this.formData
      }
      this.$http.get('/nhf-app/factorystaffnutritionraw/selectNutritionWithoutSpecialTypePage',{params}).then(res => {
        let {success,data} = res;
        if(success){
          let {records,current=1,total=0} = data;
          this.pagination.current = current
          this.pagination.total = total
          this.list = records || []
          
          // 翻页后，根据selectId设置当前页的选中状态
          this.updateCurrentPageSelection()
        }else{
          this.$message.error('查询失败')
        }
      })
    },
    onSearch(){
      // 搜索时清空选中状态
      this.selectList = []
      this.selectId = []
      this.getList({current:1,pageSize:this.pagination.pageSize})
    },
    
    // 更新当前页的选中状态
    updateCurrentPageSelection() {
      // 根据selectId设置当前页的选中状态
      this.selectList = this.list
        .filter(item => this.selectId.includes(item.id))
        .map(item => item.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.nutrientBox{
  position: relative;
}
.selectCount{
  position: absolute;
  left: 0;
  bottom: -60px;
}
.colorRed{
  color: red;
}
.nurientHead{
  display: flex;
  .left,.right{
    width: 40%;
  }
  .middle{
    width: 20%;
  }
}
.tableBox{
  padding: 0;
  margin-top: 20px;
  max-height: 500px;
  overflow-y: auto;
}
</style>